import styled from 'styled-components';
import ProB05 from 'dc/ProB05';

export const ChartWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  background: #fff;
  width: 180px;
  box-sizing: content-box;
`;

export const ProgressCircle = styled(ProB05)`
  position: relative;
`;

export const Overlay = styled.div`
  display: flex;
  z-index: 10;
  position: absolute;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
